var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#3889FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46243 11.4947C9.22052 9.85733 11.7265 8.7779 12.9804 8.25637C16.5604 6.7673 17.3043 6.50863 17.7892 6.50009C17.8959 6.49821 18.1343 6.52464 18.2887 6.64997C18.4192 6.7558 18.455 6.89875 18.4722 6.99908C18.4894 7.09942 18.5108 7.32798 18.4938 7.50657C18.2998 9.545 17.4603 14.4917 17.0332 16.7748C16.8525 17.7408 16.4967 18.0647 16.1522 18.0964C15.4036 18.1653 14.8351 17.6017 14.1101 17.1264C12.9755 16.3827 12.3345 15.9197 11.2332 15.1939C9.96037 14.3552 10.7855 13.8942 11.5108 13.1408C11.7006 12.9436 14.9991 9.94344 15.0629 9.67128C15.0709 9.63724 15.0783 9.51036 15.003 9.44336C14.9276 9.37636 14.8163 9.39927 14.736 9.41749C14.6223 9.44332 12.8097 10.6413 9.29841 13.0116C8.78392 13.3649 8.31791 13.537 7.90039 13.528C7.4401 13.518 6.55469 13.2677 5.89648 13.0538C5.08916 12.7913 4.44752 12.6526 4.50339 12.2069C4.53249 11.9748 4.85217 11.7373 5.46243 11.4947Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBlue);
export default __webpack_public_path__ + "static/media/telegram-blue.c876d120.svg";
export { ForwardRef as ReactComponent };